import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getReq, postReq } from "../middleware/AxiosApisCall";
import BulkUpload from "../Partials/BulkUpload";
import { SuccessAlert, ErrorAlert } from "../middleware/AlertMsg";
import { AiFillDelete } from "react-icons/ai";
import Loading from "../Loading";
import Select from "react-select";
import {
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper,TablePagination
} from '@mui/material';
import {HeaderTableCell,StyledTableRow,StyledTableCell} from '../Partials/TableStyle'
function TransferStock() {
  const navigate = useNavigate();
  const [bulk, setBulk] = useState(false);
  const [loading, setLoading] = useState(false);
  const [warehouseList, setWarehouseList] = useState(null);
  const [warehouseID, setWarehouseID] = useState();
  const [productsList, setProductsList] = useState([]);
  const [filteredWarehouse, setFilteredWarehouse] = useState();
  const [transferStock, setTransferStock] = useState({
    fromWarehouse: "",
    toWarehouse: "",
    products: [],
  });

  const custumStyle = {
    control: (provided) => ({
      ...provided,
      fontSize: "14px",
      width: "230px",
      lineHeight: 1.5,
      backgroundColor: "#dee1e2",
      border: "2px solid #dee1e2",
      height: "20px",
    }),
  };

  const mappedWarehouse = warehouseList?.map((info) => ({
    value: info._id,
    label: info.wareHouseName,
  }));

  const [transferProducts, setTransferProducts] = useState({
    productName: "",
    quantity: "",
  });

  const path = "sendStockTransferRequest";

  const handleProduct = (e) => {
    const { name, value } = e.target;
    setTransferProducts((prev) => ({ ...prev, [name]: value }));
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setTransferStock((values) => ({ ...values, [name]: value }));
  };

  const handleSelect = (seleted) => {
    setTransferStock((values) => ({ ...values, fromWarehouse: seleted.label }));
    setWarehouseID(seleted.value);

    const updatedDropdownTwo = warehouseList?.filter(
      (option) => option.wareHouseName !== seleted.label
    );
    setFilteredWarehouse(updatedDropdownTwo);
  };

  const fetchProductsByWarehouse = async () => {
    const response = await getReq(
      `wareHouseProduct/Datalist?id=${warehouseID}`
    );
    setProductsList(response.data);
  };

  useEffect(() => {
    if (warehouseID) {
      fetchProductsByWarehouse();
    }
  }, [warehouseID]);

  const handleProductAdd = () => {
    const { productName, quantity } = transferProducts;
    //
    const checkProductInWarehouse = productsList.find(
      (item) => item.productname === productName
    );

    if (!checkProductInWarehouse) {
      alert("product is not availble in warehouse ..!");
      setTransferProducts({
        productName: "",
        quantity: "",
      });
      return;
    }

    const duplicateProduct = transferStock.products.find(
      (item) => item.productName === productName
    );
    if (duplicateProduct) {
      alert("product already added ..!");
      setTransferProducts({
        productName: "",
      });
      return;
    }

    if (productName === "" || quantity === "") {
      return alert("Fileds Should not Empty..!");
    } else {
      const productsArray = [...transferStock.products, transferProducts];
      setTransferStock({
        ...transferStock,
        products: productsArray,
      });
      setTransferProducts({
        productName: "",
        quantity: "",
      });
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const { fromWarehouse, toWarehouse } = transferStock;
    if (fromWarehouse === "" || toWarehouse === "") {
      return alert("please Select Warehouse");
    } else {
      setLoading(true);
      const response = await postReq(path, transferStock);
      if (response.success) {
        setLoading(false);
        SuccessAlert({
          title: "Ware House",
          message: " Stock Transfer successfully",
        });
        setTransferStock({
          fromWarehouse: "",
          toWarehouse: "",
          products: [],
        });
      } else {
        setLoading(true);
        ErrorAlert({ title: "Stock Transfer failed", message: response.msg });
        setLoading(false);
      }
    }
  };

  const loadList = async () => {
    const response = await getReq(`getAllWarehouses/Datalist`);
    setWarehouseList(response?.data);
  };

  useEffect(() => {
    loadList();
  }, []);

  const { productName, quantity } = transferProducts;
  const { toWarehouse } = transferStock;

  const handleDelete = (i) => {
    const updated = transferStock.products.filter((item, index) => index !== i);
    setTransferStock({
      ...transferStock,
      products: updated,
    });
  };

  return (
    <React.Fragment>
      {loading ? (
        <Loading />
      ) : (
        <div className="add-user-container">
          <div className="headingdiv">
            <span className="componet-title"> </span>
            <div>
              <button onClick={() => navigate(-1)}>Back</button>
            </div>
          </div>
          <div className="option-btn">
            <button
              onClick={() => {
                setBulk(!bulk);
              }}
            >
              {" "}
              {bulk ? "Add Single Transfer" : "Upload Bulk Transfer"}
            </button>
          </div>

          {bulk ? (
            <BulkUpload path={"warehouseStock"} ComponentName={"Transfer"} />
          ) : (
            <>
              <form className="flex-row form-2col-ver">
                <div className="componet-sub-title">
                  <span>Transfer Stocks</span>
                </div>

                <div className="flex-row">
                  <div className="input-lable-h-div">
                    <label htmlFor="fromwarehouse">From Warehouse:</label>

                    <Select
                      styles={custumStyle}
                      options={mappedWarehouse}
                      name="fromWarehouse"
                      //  value={mappedWarehouse}
                      placeholder="Select Warehouse"
                      onChange={handleSelect}
                    />
                  </div>

                  <div className="input-lable-h-div">
                    <label htmlFor="fromwarehouse">To Warehouse:</label>

                    <select
                      name="toWarehouse"
                      value={toWarehouse}
                      onChange={handleChange}
                    >
                      <option value="Select Warehouse">Select Warehouse</option>
                      {filteredWarehouse != null ? (
                        filteredWarehouse.map((warehouse, i) => {
                          return (
                            <option key={i}>{warehouse.wareHouseName}</option>
                          );
                        })
                      ) : (
                        <option>Please Select From-Warehouse first</option>
                      )}
                    </select>
                  </div>

                  {/* <div className="input-lable-h-div">
                <button className="submit-btn" type="submit">
                  Transfer
                </button>
              </div> */}
                </div>
              </form>

              {/* // )} */}
              <div className="flex-row" style={{ margin: "25px" }}>
                <div className="componet-sub-title">
                  <span>Products details</span>
                </div>

                <div
                  className="input-lable-h-div"
                  style={{ marginTop: "25px" }}
                >
                  <label htmlFor="productName">Product</label>
                  <input
                    name="productName"
                    onChange={handleProduct}
                    list="products"
                    value={productName}
                    placeholder={"Select..."}
                    autoComplete={"off"}
                    style={{ textAlign: "left" }}
                  />
                  <datalist id="products">
                    {productsList.length > 0 ? (
                      productsList.map((item, i) => {
                        return (
                          //
                          <option key={item._id} value={item.productname}>
                            {item.productname}
                          </option>
                        );
                      })
                    ) : (
                      <option>{"Please Select Warehouse first"}</option>
                    )}
                  </datalist>

                  {/* <DataList
              name={"productName"}
              value={productName }
              path={"Product"}
              option={"productname"}
              handleChange={handleProduct}
              heading={"Product"}
            /> */}
                </div>

                <div className="input-lable-h-div">
                  <label htmlFor="quantity">Quantity:</label>
                  <input
                    name="quantity"
                    type="number"
                    value={quantity}
                    onChange={handleProduct}
                    required
                  />
                </div>
                <div className="input-lable-h-div">
                  <label htmlFor="quantity"></label>
                  <button
                    className="submit-btn"
                    style={{ width: "230px" }}
                    onClick={handleProductAdd}
                  >
                    Add
                  </button>
                </div>
              </div>
              {transferStock.products.length > 0 ? (
                <div>
                  <TableContainer component={Paper}>
                    <Table>
                      <TableHead>
                        <StyledTableRow>
                          <HeaderTableCell>Sl no</HeaderTableCell>
                          <HeaderTableCell>Product</HeaderTableCell>
                          <HeaderTableCell>Qty</HeaderTableCell>
                          <HeaderTableCell>Action</HeaderTableCell>
                        </StyledTableRow>
                      </TableHead>
                      <TableBody> 
                      {transferStock.products.map((item, i) => (
                       
                       <StyledTableRow key={i+1} sx={{
                            backgroundColor: i % 2 === 0 ? '#f5f5f5' : 'white',
                        }}>
                          <StyledTableCell>{i + 1}</StyledTableCell>
                          <StyledTableCell>{item.productName}</StyledTableCell>
                          <StyledTableCell>{item.quantity}</StyledTableCell>
                          <StyledTableCell>
                            {" "}
                            <AiFillDelete
                              value={item.id}
                              onClick={() => handleDelete(i)}
                              className="Delete-icon"
                            />
                          </StyledTableCell>
                        </StyledTableRow>
                        
                      ))}
                    </TableBody>
                  </Table>
                  </TableContainer>
                  <button
                    style={{ marginLeft: "80px" }}
                    className="submit-btn"
                    onClick={handleSubmit}
                  >
                    Submit
                  </button>
                </div>
              ) : (
                <table>
                  <tbody>
                    <tr>
                      <th style={{ color: "white" }}>No data</th>
                    </tr>
                  </tbody>
                </table>
              )}
            </>
          )}
        </div>
      )}
    </React.Fragment>
  );
}

export default TransferStock;
